// Vuetify Documentation https://vuetifyjs.com

import Vue from "vue";
import Vuetify from "vuetify/lib";
import { themePreset } from "../../src/themeConfig";
import De from 'vuetify/lib/locale/de'

Vue.use(Vuetify);


export default new Vuetify({
  theme: themePreset.theme,
  rtl: themePreset.rtl,
  lang: {
    locales: {De},
    current: 'De'
  }
});
